import React from 'react';
import { Link } from 'react-router-dom';
import * as R from 'ramda';

import featuresOverview from './../../../assets/images/placeholder/Features-Overview.svg';

export const Landing = ({ representingUser }) => {
	return (
		<article className="view-calc py-2">
			<div className="auto-view h-100 my-auto">
				<div className="container-fluid my-auto">
					<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-5 text-center">
						<img className="img-fluid mx-auto container-md-press mb-2" src={featuresOverview} alt="features overview" width="150" />
						<div className="container-default mx-auto">
							<h2 className="text-primary font-weight-bolder mt-2 mb-3">Dossier d'aide et d'accompagnement administratif</h2>
							{/* <h1 className="text-primary font-weight-bolder mt-2 mb-3">Être référent c’est quoi ? Vos avantages et votre rôle ?</h1> */}
							
						</div>
					</header>
					<section className="block container-default mx-auto">
						<p className="h4 font-weight-black mb-2 align-items-left">Être référent c’est quoi ?</p>
						<p className="mb-3">Être référent est une marque de confiance, c’est être le relais de votre proche.</p>
						<p className="h4 font-weight-black mb-2 align-items-left">Pourquoi?</p>
						<p className="mb-3">Ce service a été mis en place afin d’adapter et vous faciliter toutes les démarches administratives que vous aurez à faire et à envoyer le moment venu.</p>
						<h4 className="h5 text-uppercase font-weight-bolder mt-0 mb-2">Notre service</h4>
						<div className="card mb-3">
							<div className="card-body">
								<div className="d-flex align-items-center small">
									<i className="eva eva-checkmark-outline text-success mr-2"></i>
									<span className="o-70">Vous propose les courriers personnalisés</span>
								</div>
								<div className="d-flex align-items-center small">
									<i className="eva eva-checkmark-outline text-success mr-2"></i>
									<span className="o-70">Crée les démarches et les envoie en fonction des délais légaux</span>
								</div>
								<div className="d-flex align-items-center small">
									<i className="eva eva-checkmark-outline text-success mr-2"></i>
									<span className="o-70">Les archives pour vous, dans un coffre-fort numérique disponible</span>
								</div>
								<div className="d-flex align-items-center small">
									<i className="eva eva-checkmark-outline text-success mr-2"></i>
									<span className="o-70">Vous permet de déposer simplement les documents de la famille (livrets, pièces d’identités…) dans un espace bibliothèque que vous pouvez rendre accessible.</span>
								</div>
							</div>
						</div>
						<div className="flex-row align-items-center justify-content-end">
							{
								R.isNil(representingUser) ? 
									''
								:
									<Link className="btn btn-secondary" to={`/facilita/${representingUser.id}/declarer/step1`}>Je souhaite déclarer le décès</Link>
							}
							
							<button type="button" className="btn btn-primary ml-2 shadow-xs" to={`/index`} onClick={() => {
								sessionStorage.removeItem("access_token");
								setTimeout(() => {
									window.location = '/index';
								}, 100);
							}}>Quitter</button>
						</div>
					</section>
				</div>
			</div>
		</article>
	)
}